import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@material-ui/core/';
import Form from 'components/Form/FormTwoColumns';
import { CheckCircleOutline } from '@material-ui/icons';
import Title from 'components/TitleWithIcon';

export default function RechazarPorCasoEspecial(props) {

    const enviarSolicitudCasoEspecial = () =>{
        var datos = {observacion: elements.observacion.value, noTickets: props.citizenDataSpecialCase}
        props.handleClose();
    }
    const [elements,setElements] = useState({
        observacion: { idelement: "observacion",  value:'', label: "Observación", pattern:"^[\\w1-9 _Ññ.,!¡\"#$%&/()=¿?'@*-]{0,1024}$", validators: ['required'], errorMessages:['Observación requerido, Sin espacios al inicio y final'], isError:false, elementType:'input' },
        // contraseña: {  idelement: "contraseña",  value:'', label: "Contraseña *", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:;{}+=^~|%*¿?&/-]\\S{6,20}$", validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' },
    });    
    const [buttonList,setButtonList]= React.useState({
        "next":{"label":"procesar solicitud","icon": <CheckCircleOutline />,"callback":enviarSolicitudCasoEspecial,"loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},   
    });
return (
    <Dialog
        open={props.open} onClose={props.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description"
    >
        <Title title="Enviar a Caso Especial" icon={"/menu/Document.png"}/>
        <DialogContent>
            <DialogContentText  id="alert-dialog-description">
                Al generar la solicitud por "Caso Especial", la solicitud pasará a estado de "Nuevo solicitud"
            </DialogContentText >
            <Form   elements= {elements}  buttonList={buttonList} BotonCerrar={props.handleClose} 
            />            
        </DialogContent>
    </Dialog>
);
}
